import React from 'react';
import styled from '@emotion/styled';
import type { PositionProps } from 'styled-system';
import { position } from 'styled-system';

import { BaseLabel } from 'common/components/BaseLabel';
import { useDisclaimerDrawer } from 'common/components/LegalDisclaimer/hooks/use-disclaimer-drawer';
import type { ThemeBottomProps, ThemeLeftProps } from 'common/theme/system-utilities';
import { themeBottom, themeLeft } from 'common/theme/system-utilities';

interface TeaserInfoBadgeProps {
  badgeText: string;
  drawerContent: string;
  className?: string;
}

const TeaserInfoBadgeComponent = ({
  badgeText,
  drawerContent,
  className,
}: TeaserInfoBadgeProps) => {
  const onClick = useDisclaimerDrawer({ content: drawerContent });

  return (
    <BaseLabel
      className={className}
      testId="disclaimer-link"
      iconTestId="info-icon"
      onClick={onClick}
    >
      {badgeText}
    </BaseLabel>
  );
};

export const TeaserInfoLabel = styled(TeaserInfoBadgeComponent)<
  PositionProps & ThemeBottomProps & ThemeLeftProps
>`
  ${position};
  ${themeBottom};
  ${themeLeft};
`;
